/*
*
* File JS componente Block Experience
*
*/

// IMPORT LIBRERIE ESTERNE
//--------------------------------------------------------------------//

import 'swiper/css/bundle';
import Swiper from 'swiper/bundle';

//--------------------------------------------------------------------//


// IMPORT SCSS PER LA COMPILAZIONE
//--------------------------------------------------------------------//

import './block-experience.scss';

//--------------------------------------------------------------------//


// EXPORT COMPONENTE
//--------------------------------------------------------------------//

const blockExperience = () => {
    let swiperExperience = document.querySelector('.block-experience .swiper-container'); 

    if (!swiperExperience) return;

    let args = {
        breakpoints: {
            0: {
                slidesPerView: 1.1,
                spaceBetween: 10,
            },
            500: {
                slidesPerView: 1.6,
                spaceBetween: 18,
            },
            768: {
                slidesPerView: 2.1,
                spaceBetween: 20,
            },
            1024: {
                slidesPerView: 3,
                spaceBetween: 25,
            },
        },
        a11y: {
            enabled: true,
            prevSlideMessage: 'Previous slide',
            nextSlideMessage: 'Next slide',
            firstSlideMessage: 'This is the first slide',
            lastSlideMessage: 'This is the last slide',
            paginationBulletMessage: 'Go to slide {{index}}',
            notificationClass: 'swiper-notification'
        },
    };

    new Swiper(swiperExperience, args);
}

export default blockExperience;

//--------------------------------------------------------------------//